import React from 'react';

export default function CategoryCard({ category, navigateTo }) {
    const handleClick = () => {
        navigateTo('listings', { category: category.slug, keywords: '', location: '' });
    };

    return (
        <div 
            onClick={handleClick} 
            className={`relative flex flex-col items-center justify-center p-6 rounded-2xl cursor-pointer shadow-sm hover:shadow-xl transform hover:-translate-y-1 transition-all duration-300 group border border-gray-100 h-40 md:h-48 ${category.colorClass}`}
        >
            {category.icon}
            <h3 className="text-center font-bold text-sm md:text-base tracking-wide transition-colors">{category.name}</h3>
        </div>
    );
}
